export enum AddressType {
    Home = 1,
    Work = 2,
    Emergency = 3,
    Mail = 4
}